document.addEventListener("DOMContentLoaded", () => {
  // 1) Finde das Header-Suchfeld (du markierst es ja in theme.liquid mit .mz-search-input)
const input =
  document.querySelector("#mz-search-input") ||
  document.querySelector(".mz-search-input") ||
  document.querySelector('header input[type="search"]') ||
  document.querySelector('header form[action*="/search"] input[name="q"]');

  if (!input) return;

  // 2) I18N (aus theme.liquid: window.MZ_SEARCH_I18N)
  const i18n = (window.MZ_SEARCH_I18N || {});
  const T = (key, fallback) => (typeof i18n[key] === "string" && i18n[key].trim() ? i18n[key] : fallback);

  // Placeholder richtig setzen (und "Translation missing..." überschreiben)
  const placeholder = T("placeholder", "Suche…");
  if (!input.getAttribute("placeholder") || String(input.getAttribute("placeholder")).includes("Translation missing")) {
    input.setAttribute("placeholder", placeholder);
  }

  // mz-article-id-search-v1: numeric article IDs are searched as product-id query (id:<number>)
  const ARTICLE_ID_RE = /^\d{10,20}$/;
  function normalizeSearchQuery(raw) {
    const q = String(raw || "").trim();
    if (!q) return q;
    return ARTICLE_ID_RE.test(q) ? `id:${q}` : q;
  }

  // 3) Root-Pfad für Märkte/Sprachen (WICHTIG: /it/ etc.!)
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";

  // 4) Results-Container erstellen (falls nicht vorhanden)
  let results = document.getElementById("search-results");
  if (!results) {
    results = document.createElement("div");
    results.id = "search-results";
    document.body.appendChild(results);
  }

  // 5) Positionierung unter dem Input (reagiert auf Resize/Scroll)
  function positionResults() {
    const r = input.getBoundingClientRect();
    results.style.position = "absolute";
    results.style.left = (window.scrollX + r.left) + "px";
    results.style.top  = (window.scrollY + r.bottom + 8) + "px";
    results.style.width = r.width + "px";
    results.style.display = "block";
  }

  function hideResults() {
    results.style.display = "none";
    results.innerHTML = "";
  }

  // 6) Debounce
  let tId = null;
  const debounce = (fn, wait = 250) => (...args) => {
    clearTimeout(tId);
    tId = setTimeout(() => fn(...args), wait);
  };

  // 7) Render
  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, (m) => ({
      "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#039;"
    }[m]));
  }

  function render({ collections = [], products = [] }) {
    const collectionsLabel = T("collections", "Kategorien");
    const noResults = T("no_results", "Keine Treffer.");

    let html = `<div class="mz-search-dropdown">`;

    if (collections.length) {
      html += `<div class="mz-search-section"><div class="mz-search-title">${escapeHtml(collectionsLabel)}</div><ul>`;
      collections.forEach(c => {
        html += `<li><a href="${c.url}">${escapeHtml(c.title)}</a></li>`;
      });
      html += `</ul></div>`;
    }

    if (products.length) {
      html += `<div class="mz-search-section"><ul>`;
      products.forEach(p => {
        const img = p.img ? `<img src="${p.img}" alt="" width="40" height="40" loading="lazy">` : "";
        html += `<li><a href="${p.url}">${img}<span>${escapeHtml(p.title)}</span></a></li>`;
      });
      html += `</ul></div>`;
    }

    if (!collections.length && !products.length) {
      html += `<div class="mz-search-empty">${escapeHtml(noResults)}</div>`;
    }

    html += `</div>`;
    results.innerHTML = html;

    positionResults();
  }

  // 8) Shopify suggest.json abrufen (ohne resources[limit], weil das bei dir schon 422 gemacht hat)
  async function fetchSuggest(q) {
    // wichtig: root davor, damit /it/search/suggest.json genutzt wird
    const url =
      `${root}search/suggest.json?q=${encodeURIComponent(q)}` +
      `&${encodeURIComponent("resources[type]")}=${encodeURIComponent("product,collection")}`;

    const res = await fetch(url, { credentials: "same-origin", cache: "no-store" });
    if (!res.ok) throw new Error("HTTP " + res.status);
    const data = await res.json();

    // Shopify liefert je nach Theme-Struktur leicht anders:
    const layer = (data && data.resources && (data.resources.results || data.resources)) || data || {};
    const rawProducts = layer.products || [];
    const rawCollections = layer.collections || [];

    const products = rawProducts.slice(0, 10).map(p => ({
      title: p.title || (p.fields && p.fields.title) || "",
      url: p.url || p.url_with_variant || "",
      img: (p.featured_image && (p.featured_image.url || p.featured_image)) || (p.image && (p.image.url || p.image)) || ""
    }));

    const collections = rawCollections.slice(0, 10).map(c => ({
      title: c.title || (c.fields && c.fields.title) || "",
      url: c.url || ""
    }));

    return { products, collections };
  }

  // 9) Search Flow
  async function doSearch(q) {
    results.style.display = "block";
    results.innerHTML = `<div class="mz-search-loading">${escapeHtml(T("searching", "Suche…"))}</div>`;
    positionResults();

    try {
      const out = await fetchSuggest(q);
      render(out);
    } catch (e) {
      console.error("MZ search error:", e);
      render({ collections: [], products: [] });
    }
  }

  // 10) Events
  input.addEventListener("input", debounce(() => {
    const raw = input.value.trim();
    if (raw.length < 2) return hideResults();
    doSearch(normalizeSearchQuery(raw));
  }, 250));

  input.addEventListener("focus", () => {
    const raw = input.value.trim();
    if (raw.length >= 2) doSearch(normalizeSearchQuery(raw));
  });

  const searchForm = input.closest("form[action*=\"/search\"]") || input.form;
  if (searchForm) {
    searchForm.addEventListener("submit", () => {
      const raw = input.value.trim();
      const normalized = normalizeSearchQuery(raw);
      if (normalized && normalized !== raw) input.value = normalized;
    });
  }

  window.addEventListener("scroll", () => {
    if (results.style.display === "block") positionResults();
  }, { passive: true });

  window.addEventListener("resize", () => {
    if (results.style.display === "block") positionResults();
  });

  document.addEventListener("click", (ev) => {
    if (ev.target === input) return;
    if (results.contains(ev.target)) return;
    hideResults();
  });

  // Optional: ESC schließt Dropdown
  input.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hideResults();
  });
});


/* mz-vehicle-finder-cache-fallback-v1 */
(function(){
  function install(){
    if(document.querySelector('[data-mz-vf]')) return;
    var forms=document.querySelectorAll('.mz-search-form'),i,wrap;
    if(!forms.length) return;
    for(i=0;i<forms.length;i++){
      wrap=document.createElement('div');wrap.className='mz-vf';wrap.setAttribute('data-mz-vf','');wrap.setAttribute('data-source','/cdn/shop/t/11/assets/mz-vehicle-collections.json?v=34039197277395146511787741340');
      wrap.innerHTML='<button class="mz-vf__toggle" type="button" aria-expanded="false">Marke &amp; Modell</button><div class="mz-vf__panel"><select data-brand aria-label="Marke"><option value="">Marke wählen</option></select><select data-model aria-label="Modell" disabled><option value="">Modell wählen</option></select><button class="mz-vf__go" data-go type="button" disabled>Zum Modell</button></div>';
      forms[i].parentNode.insertBefore(wrap,forms[i].nextSibling);
    }
    if(!document.querySelector('link[data-mz-vf-css]')){var l=document.createElement('link');l.rel='stylesheet';l.setAttribute('data-mz-vf-css','');l.href='/cdn/shop/t/11/assets/mz-vehicle-finder.css?v=77326696256045982001787741340';document.head.appendChild(l)}
    if(!document.querySelector('script[data-mz-vf-js]')){var j=document.createElement('script');j.src='/cdn/shop/t/11/assets/mz-vehicle-finder.js?v=169944288135464105121787741340';j.defer=true;j.setAttribute('data-mz-vf-js','');document.head.appendChild(j)}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',install);else install();
})();
